import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'months'
})
export class MonthsPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value) return `${value} months`;
  }

}
